export function hexFromPercentage(percentage: string): string {
    const MAX_BRIGHTNESS = 255;
    const decimalValue = Math.round((parseInt(percentage, 10) * MAX_BRIGHTNESS) / 100);
    const hexValue = decimalValue.toString(16).toUpperCase();

    // Add a leading 0 to the hex value if it is less than 10
    return hexValue.length < 2 ? `0${hexValue}` : hexValue;
}
